const pageToPrint = {
  vcrPage: 'vcr-page',
  financialOverview: 'financial-overview',
}
export default pageToPrint
